import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import {
  CreateAddressTypeModel,
  DeleteAddressTypeModel,
  SearchAddressTypeModel,
} from '../../../models/address-type.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class AddressTypeService {
  private baseUrl = environment.baseUrl
  private resource = 'TipoEndereco'

  constructor(private httpClient: HttpClient) {}

  public createAddressType(
    model: CreateAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editAddressType(
    model: any,
    // model: EditAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteAddressType(
    model: DeleteAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedAddressType(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listAddressType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getAddressTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedAddressType(
    page: number,
    rows = 15,
    model: SearchAddressTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
